/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

const CONTRIBUTOR = "Contributor";
const VIEWER = "Viewer";
const OWNER = "Owner";
const MIC_ENABLED = "#micEnabled";
const MIC_DISABLED = "#micDisabled";
const INVITATION = "Invitation";
const JOINING_REQUEST = "Joining Request";
const ACCEPT_CONTRIBUTOR = "Accept Contributor";
const INVITE_CONTRIBUTOR = "Invite Contributor";
const ACCEPT_VIEWER = "Accept Viewer";
const INVITE_VIEWER = "Invite Viewer";
const DECLINE = "Decline"
const ACCEPT = "Accept"
const CANCEL = "Cancel"

module.exports = {
    CONTRIBUTOR,
    VIEWER,
    INVITATION,
    JOINING_REQUEST,
    ACCEPT_CONTRIBUTOR,
    INVITE_CONTRIBUTOR,
    ACCEPT_VIEWER,
    INVITE_VIEWER,
    DECLINE,
    ACCEPT,
    CANCEL,
    OWNER,
    MIC_DISABLED,
    MIC_ENABLED
}